import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { StackView } from '../StackView';
export function Section(_ref) {
  var subdued = _ref.subdued,
      restProps = _objectWithoutPropertiesLoose(_ref, ["subdued"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    width: "100%",
    padding: 1,
    backgroundColor: subdued ? 'surfaceSecondary' : undefined
  }, restProps));
}
Section.displayName = 'Card.Section';